"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Image from "next/image";
import MixedFontText from "@/components/MixedFontText";
import ItemToggleButton from "../Buttons/ItemToggleButton";
import sanitizeDOMData from "@/utils/sanitizeDOMData";
export type Section3Item = {
  id: string;
  title: string;
  description: string;
  image: string;
  tab: string;
};

export default function Section3({
  SECTION3_ITEMS,
}: {
  SECTION3_ITEMS?: Section3Item[];
}) {
  const [activeId, setActiveId] = useState(SECTION3_ITEMS?.[0].id);
  const activeItem = SECTION3_ITEMS?.find((i) => i.id === activeId)!;
  if (!SECTION3_ITEMS) return null;
  return (
    <section className="relative bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-16 items-end">
          {/* LEFT CONTENT */}
          <div className="space-y-8 lg:pr-12 min-h-[200px]">
            <MixedFontText
              text={activeItem.title}
              wrapperClassName="text-black/80  leading-tight"
              normalClassName="text-2xl md:text-3xl"
              highlightClassName="text-3xl md:text-4xl font-bold text-primary"
            />

            <div
              className="
          max-w-lg opacity-90
          text-xs sm:text-sm md:text-base
          line-clamp-4 md:line-clamp-none
        "
            >
              {sanitizeDOMData(activeItem.description)}
            </div>

            {/* SELECTOR BUTTONS */}
            <div className="flex flex-wrap gap-4 pt-6">
              {SECTION3_ITEMS.map((item) => {
                const isActive = item.id === activeId;

                return (
                  <ItemToggleButton
                    key={item.id}
                    label={item.tab}
                    active={isActive}
                    onClick={() => setActiveId(item.id)}
                  />
                );
              })}
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="relative lg:absolute lg:right-0 lg:w-[55vw] lg:max-w-[55vw] overflow-hidden top-0">
            <div className="relative w-full aspect-[14/10] max-h-[65vh] overflow-hidden">
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeItem.id}
                  initial={{ opacity: 0, scale: 0.98 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.98 }}
                  transition={{ duration: 0.4, ease: "easeOut" }}
                  className="absolute inset-0"
                >
                  <Image
                    src={activeItem.image}
                    alt=""
                    fill
                    className="object-contain"
                    priority
                    sizes="(min-width: 1024px) 50vw, (min-width: 768px) 70vw, 90vw"
                  />
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
